import 'jquery';
import { debounce } from 'throttle-debounce';
import qs from 'qs';
import {
  timeoutDurationStandard,
  timeoutDurationInstant,
  categoryQuickSearchDisplayLimit,
  categoryQuickSearchFetchLimit,
} from '../../constants';

$(() => {
  let xhrCategories = null;
  const templateCategoryTag = $('script[data-template="category-tag"]').text();
  const templateCategorySuggestion = $('script[data-template="category-suggestion"]').text();
  const $quickSearchForm = $('.quick-search');
  const $quickSearchInput = $('#quick-search-category');
  const $searchSuggestions = $('#quick-search-suggestions');
  const $searchSuggestionsTags = $('#quick-search-tags');

  setTimeout(() => $quickSearchInput.data('synthetic', true).trigger('change'), timeoutDurationInstant);

  const updateAutocomplete = ({
    show,
    showLoading,
    hideLoading,
    removeSuggestions,
  }) => {
    $searchSuggestions.toggleClass('hidden', !show);

    if (removeSuggestions) {
      $searchSuggestions.find('.quick-search__suggestion').remove();
    }

    if (showLoading) {
      $searchSuggestions.removeClass('loading');
    }

    if (hideLoading) {
      $searchSuggestions.addClass('loading');
    }
  };

  const populateAutocomplete = (categories) => {
    $searchSuggestions.find('.quick-search__suggestion').remove();
    categories?.forEach((category) => {
      if ($searchSuggestionsTags.find(`[data-id="${category.key}"]`).length) {
        return false;
      }

      const $item = $(templateCategorySuggestion);

      $item.html(category.context.category);
      $item.attr('data-id', category.key);
      $searchSuggestions.prepend($item);

      return true;
    });

    let height = $searchSuggestions
      .children()
      .toArray()
      .slice(0, categoryQuickSearchDisplayLimit)
      .reduce((total, item) => total + $(item).innerHeight(), 0);

    if (categories?.length >= categoryQuickSearchDisplayLimit) {
      height -= 20;
    }

    $searchSuggestions.css('max-height', height + 1);
  };

  const generateQuickSearchUrlParams = () => {
    const idManufacturer = parseInt($('.filterCarManufacturer').val(), 10);
    const idModel = parseInt($('.filterCarModelCategories').val(), 10);
    const idModification = parseInt($('.filterCarModification').val(), 10);
    const idsCategories = $searchSuggestionsTags.find('.tags__items').map((_, item) => $(item).attr('data-id'));
    const textQuery = $quickSearchInput.val();
    const params = {
      ...(idManufacturer ? { man_id: idManufacturer } : {}),
      ...(idModel ? { cmc: idModel } : {}),
      ...(idModification ? { cm: idModification } : {}),
      ...(idManufacturer ? {
        mfi: `${[
          ...(idManufacturer ? [idManufacturer] : []),
          ...(idModel ? [idModel] : []),
          ...(idModification ? [idModification] : []),
        ].join(',')};`,
      } : {}
      ),
      ...(idsCategories?.length ? {
        cpc: idsCategories.toArray().join(','),
      } : {
        q: textQuery,
      }),
    };

    return qs.stringify(params, {
      arrayFormat: 'comma', addQueryPrefix: true, skipNulls: true, encode: false,
    });
  };

  const doSearch = debounce(150, (searchQuery = null) => {
    if (typeof xhrCategories !== 'undefined' && xhrCategories !== null) {
      xhrCategories.abort();
    }
    xhrCategories = $.ajax({
      url: `${window.RRR_SITE_HOST}/search/suggestions_categories?limit=${categoryQuickSearchFetchLimit}`,
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      data: {
        query: searchQuery ?? $('#search-field').val(),
      },
      success({ category3: categories }) {
        populateAutocomplete(categories);
        updateAutocomplete({
          show: !!categories?.length,
          hideLoading: true,
        });
      },
      error() {
      },
    });
  });

  $(document).on('click', '.cars_list__links-js', function (e) {
    $('.cars_list').toggleClass('cars_list--all');
    $(this).hide();
    e.preventDefault();
  });

  $(document).on('select2:select', '#query-manufacturer', function () {
    if ($(this).val() === '-') {
      $('#query-model').html(`<option value='-' >${window.TRANSLATIONS.labels.selectModel}</option>`).attr('disabled', false);
      $('#query-model').prop('disabled', true).trigger('change');
    }
    $.ajax({
      type: 'POST',
      url: `/api/ajax/getModelsByManufacturer/${$(this).val()}`,
      contentType: 'application/json; charset=utf-8',
      dataType: 'json',
      success(data) {
        if (data.error === undefined) {
          $('#query-model').html(`<option value='-' >${window.TRANSLATIONS.labels.selectModel}</option>`).attr('disabled', false);
          $.each(data.list, (key, value) => {
            $('#query-model').append(`<option value='${key}'>${value}</option>`);
          });
          $('#query-model').trigger('change');
        }
      },
    });
  });

  $(document).on('focus', '#quick-search-category', function () {
    $(this).select();
  });

  $(document).on('input propertychange dblclick focus', '#quick-search-category', function () {
    const value = $(this).val().trim();

    if (value && value.length >= 3) {
      updateAutocomplete({
        show: true,
        showLoading: true,
      });
      doSearch(value);
    } else if (value.length < 3) {
      updateAutocomplete({
        show: true,
        showLoading: true,
      });
    } else {
      updateAutocomplete({
        show: false,
      });
    }
  });

  $(document).on('click', '.quick-search__suggestion', function () {
    const categoryId = $(this).attr('data-id');
    const categoryTitle = $(this).html();
    updateAutocomplete({
      show: false,
      hideLoading: true,
    });

    if ($searchSuggestionsTags.find(`[data-id="${categoryId}"]`).length) {
      return false;
    }

    const $tag = $(templateCategoryTag);
    $tag.attr('data-id', categoryId);
    $tag.find('.tags__links__text').html(categoryTitle);
    $searchSuggestionsTags.append($tag);
    $quickSearchInput.val(categoryTitle);

    return true;
  });

  $(document).on('click', '#quick-search-tags .icon-close', function () {
    const $tag = $(this).parents('.tags__items');
    const categoryTitle = $tag.find('.tags__links__text').text();

    if ($quickSearchInput.val() === categoryTitle) {
      $quickSearchInput.val('').trigger('change');
    }

    $tag.remove();
  });

  $(document).on('submit', 'form.quick-search', (e) => {
    e.preventDefault();
    const urlSearch = $quickSearchForm.data('url-search');
    const urlParams = generateQuickSearchUrlParams();

    window.location = `${urlSearch}${urlParams}`;
    return false;
  });

  $('body').on('click', (event) => {
    if (!$(event.target).is('#quick-search-category, #quick-search-suggestions')) {
      updateAutocomplete({
        show: false,
        hideLoading: true,
        removeSuggestions: true,
      });
    }
  });
});
